<ng-container [ngSwitch]="displayType">
  <ng-container *ngSwitchCase="layoutDisplayType.READ_ONLY">
    <img #fileImage
         [attr.id]="id"
      class="image-auto"
      [ngStyle]="{'height.px':imageHeight, 'width.px':imageWidth}"
      [style.cursor]="this.field?.linkNavigation ? 'pointer' : ''"
      [src]="imageUrl | async"
      soho-alert
      alt="{{imageAltText}}"
      (click)="onClickEvent($event)"
     [attr.tabindex]="isInAccessibilityMode ? 0 : null"
    />
  </ng-container>
  <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
    <div
      [ngClass]="{
        'container': true,
        'lm-missing-image': missingImage,
        'lm-random-bg': isRandomBackground,
        'lm-foreground-text': isForeGroundText
      }"
      [ngStyle]="{'height.px':imageHeight, 'width.px':imageWidth}"
      lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : foreGroundText || fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
    >
      <ng-container *ngIf="foreGroundText && (missingImage | async); else ShowImage;">
<!--        [ngStyle]="{'height.px': lines ? (lines * 20) : 100, 'width.px': lines ? (lines * 20) : 100 }"-->
            <span
                [attr.id]="id"
                class="{{bgColorClass}}"
                [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                [ngStyle]="{'height.px':imageHeight, 'width.px':imageWidth, 'font-size.px': imageHeight / 2}"
                soho-context-menu
                [menu]="menuId"
                trigger="click"
                (beforeopen)="onBeforeOpen()"
                soho-alert
                soho-input-validate
                (error)="onError($event)"
                (valid)="onValid($event)">
                {{foreGroundText}}
            </span>

      <ul *ngIf="hasUpdateAction" soho-popupmenu attr.id="{{menuId}}">
        <li soho-popupmenu-item *ngFor="let menuEntry of contextEntries; trackBy: trackByMenuId" [isDisabled]="menuEntry.disabled">
          <a soho-popupmenu-label [id]="menuEntry.menuId" menuId="{{menuEntry.menuId}}" (click)="onImageMenuFired(menuEntry.menuId)">{{menuEntry.text}}</a>
        </li>
      </ul>
      </ng-container>

      <ng-template #ShowImage>
        <img #fileImage
          [attr.id]="id"
          [src]="imageUrl | async"
          class="image-auto"
          [ngStyle]="{'height.px':imageHeight, 'width.px':imageWidth}"
          [attr.tabindex]="0"
          soho-context-menu
          [menu]="menuId"
          trigger="click"
          (beforeopen)="onBeforeOpen()"
          soho-alert
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
          alt="{{imageAltText}}"
          title="{{imageAltText}}"/>
        <canvas [ngStyle]="{'display':'none', 'height.px':imageHeight, 'width.px':imageWidth}" #imgCanvas></canvas>
        
        <ul *ngIf="hasUpdateAction" soho-popupmenu id="{{menuId}}">
          <li soho-popupmenu-item *ngFor="let menuEntry of contextEntries; trackBy: trackByMenuId" [isDisabled]="menuEntry.disabled">
            <a soho-popupmenu-label [id]="menuEntry.menuId" menuId="{{menuEntry.menuId}}" (click)="onImageMenuFired(menuEntry.menuId)">{{menuEntry.text}}</a>
          </li>
        </ul>
      </ng-template>

      <input #fileInput type="file" [name]="bindId" class="hideInput" (change)="onFileChanged($event)"/>
    </div>
  </ng-container>
</ng-container>
